//DESKTOP | LAPTOP | TABLET
import React from "react";
import Hero from "./hero/hero";

const HeaderLarge = () => {
  return (
    <div className="relative overflow-hidden max-w-[1400px] mx-auto">
      <Hero />
    </div>
  );
};

export default HeaderLarge;
